import React from 'react';
import './TabComponent.css';
import transaction from '../../assets/img/transaction.jpg';
import respondent from '../../assets/img/respondent.png';
import logo from '../../assets/img/diginsight.png';

const TabComponent = () => {
  const email = JSON.parse(localStorage.getItem('userData'))?.email;

  const tabs = [
    {
      id: 1,
      label: 'Transactions',
      image: transaction,
      content: 'Content available',
      isRoute: true,
      route: '/overallshares',
    },
    {
      id: 2,
      label: 'Respondent',
      image: respondent,
      content: 'Content available',
      isRoute: email, // Only active if email exists
      route: '/respondents',
    },
  ];

  const handleNavigate = (tab) => {
    if (tab.isRoute) {
      window.location.href = tab.route;
    }
  };

  return (
    <div className="tab-wrapper">
      {/* Header */}
      {/* <div className="top-header">
        <div className="header-text">
          <h2>Welcome to PDQ (Payments Data Query)</h2>
        </div>
      </div> */}

      {/* Cards */}
      <div style={{ width: '100%' }}>
        <div className="top-header">
          <h2>Welcome to PDQ (Payments Diary Query)</h2>
        </div>
        <div className="card-container">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`feature-card ${!tab.isRoute ? 'disabled' : ''}`}
            >
              <span style={{ textAlign: 'start' }}>
                <h2>{tab.label}</h2>
                <p>{tab.content}</p>
              </span>
              <div className='transresp'>
                {/* <img src={tab.image} alt={tab.label} className="feature-img" /> */}
                <img
                  src={tab.image}
                  alt={tab.label}
                  className={`feature-img ${tab.label === 'Respondent' ? 'respondent-img' : ''}`}
                />

              </div>
              <button
                className={`feature-btn ${!tab.isRoute ? 'disabled-btn' : ''}`}
                onClick={() => handleNavigate(tab)}
                disabled={!tab.isRoute}
              >
                View {tab.label}
                <p className="arrow">&#11166;</p>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabComponent;
